import { PushParamsType } from 'common/interfaces';
import { ReactElement } from 'react';

export interface SimpleTableProps<TRow> {
  columns: SimpleTableColumn<TRow>[];
  rowIdPropName: keyof TRow;
  rows?: TRow[];
  editRowConfig?: EditRowConfig<TRow>;
}

export interface EditRowConfig<TRow> {
  isRowEditable: (row: TRow) => boolean;
  editHandler: (row: TRow) => void;
}

export interface SimpleTableColumnBase<TRow> {
  title: string;
  propName: keyof TRow;
  type: SimpleTableColumnTypes;
  width?: string;
}

export interface SimpleTableColumnLink<TRow> extends SimpleTableColumnBase<TRow> {
  type: SimpleTableColumnTypes.Link;
  getLink: (row: TRow) => PushParamsType;
}

export interface SimpleTableColumnText<TRow> extends SimpleTableColumnBase<TRow> {
  type: SimpleTableColumnTypes.Text;
  placeholder?: ReactElement;
}

export interface SimpleTableColumnArrow<TRow> extends SimpleTableColumnBase<TRow> {
  type: SimpleTableColumnTypes.Arrow;
}

export interface SimpleTableColumnMenu<TRow> extends Omit<SimpleTableColumnBase<TRow>, 'propName'> {
  type: SimpleTableColumnTypes.Menu;
  menuItems: { label: string; icon: ReactElement; onClick: (row: TRow) => void }[];
}

export interface SimpleTableColumnCustom<TRow> extends Omit<SimpleTableColumnBase<TRow>, 'propName'> {
  type: SimpleTableColumnTypes.Custom;
  headerComponent: ReactElement;
  rowComponent: (row: TRow) => ReactElement<TRow>;
}

export type SimpleTableColumn<TRow> =
  | SimpleTableColumnText<TRow>
  | SimpleTableColumnLink<TRow>
  | SimpleTableColumnArrow<TRow>
  | SimpleTableColumnMenu<TRow>
  | SimpleTableColumnCustom<TRow>;

export enum SimpleTableColumnTypes {
  Text = 'text',
  Link = 'link',
  Arrow = 'arrow',
  Menu = 'menu',
  Custom = 'custom'
}
